import { Navigate,Outlet } from "react-router-dom"

export const ProtectedRoutes =()=>{


    const isAuth = localStorage.getItem('isAuth');
    return isAuth ? <Outlet/> : <Navigate to="/"/>

}